import Enum from "../../../enums/Enum";

const EnumAppointmentSource = new Enum({
    MEDAI: "Med-AI",
    WEBSITE: "Okadoc",
    CHATBOT: "Chatbot"
});

export default EnumAppointmentSource;